export default {
  en: {
    title: "",
  },
  pl: {
    title: "Harmonogram Hackathonu",
    subtitle:
      " ",
    button: "Hackathon &rarr;",
    button2: "Sprzątanie rzeki &rarr;",
    tabs: [
      {
        id: "1",
        day: "Dzień 1",
        dateDetails: "Piątek - 26 czerwca 2026",
        tabHours: [
          {
            hours: "17:00 - 18:00",
            text: "Rejestracja uczestników",
          },
          {
            hours: "18:00 - 18:15",
            text: "Oficjalne otwarcie hackathonu",
          },
          {
            hours: "18:15 - 18:20",
            text: "Simplito - Sztuczna inteligencja i cyberbezpieczeństwo - flash talk",
          },
          {
            hours: "18:30 - 19:10",
            text: "Panel dyskusyjny na temat trendów i wyzwań",
          },
          {
            hours: "19:10 – 21:00",
            text: "Formowanie zespołów, teambuilding",
          },
          {
            hours: "19:30",
            text: "Pizza",
          },
          {
            hours: "21:00 - ...",
            text: "Sesja mentoringowa + praca nad projektami",
          },
        ],
      },
      {
        id: "2",
        day: "Dzień 2",
        dateDetails: "Sobota - 27 czerwca 2026",
        tabHours: [
          {
            hours: "09:00",
            text: "Joga na dzień dobry (ok 1 h)",
          },
          // {
          //   hours: "11:00",
          //   text: "Warsztaty tworzenia z prezentacji",
          // },
          {
            hours: "12:00 - 14:00",
            text: "Sesje mentoringowe wg. dyżurów dostępności mentorów",
          },
          {
            hours: "13:00",
            text: "Pizza",
          },
          {
            hours: "15:00 - 15:30",
            text: "Warsztaty z pitchingu",
          },
          {
            hours: "16:00 - 19:00",
            text: "Mentoring",
          },
          {
            hours: "19:00",
            text: "Networking/Integracja"
          },
        ],
      },
      {
        id: "3",
        day: "Dzień 3",
        dateDetails: "Niedziela - 28 czerwca 2026",
        tabHours: [
          {
            hours: "10:00",
            text: "Spacer po wydziale Biologii",
          },
          {
            hours: "10:30 - 12:30",
            text: "Próbne prezentacje",
          },
          {
            hours: "12:30 - 14:00",
            text: "Sesje mentoringowe według dyżurów dostępności mentorów",
          },
          {
            hours: "14:00",
            text: "Pizza",
          },
          {
            hours: "16:00 - 17:45",
            text: "Finałowe prezentacje projektów ze ścieżek: człowiek, natura, technologia",
          },
          {
            hours: "17:45 - 18:00",
            text: "Obrady Jury"
          },
          {
            hours: "18:00",
            text: "And the winner is... ogłoszenie wyników",
          },
        ],
      },
    ],
  },
}
